<template>
  <div>
    <div class="control" v-drag :style="dialogStyle">
      <h1>
        <logo width="42" color="#fff" />
        <span>
          Printable Calendar<br />
          <small>[ Weekly Horizontal ]</small>
        </span>
      </h1>
      <div class="control-inner">
        <div>
          <label>Starting date</label>
          <input type="date" v-model="date" />
        </div>
        <div>
          <label>Number of weeks</label>
          <input type="number" min="1" max="12" v-model="weekNum" />
        </div>
      </div>
      <footer>
        <p>
          Copyright ©
          <a href="https://kinbi.net" target="_blank" rel="noopener"
            >Near Future Arts Lab Co.,Ltd.</a
          >
          All Rights Reserved.
        </p>
      </footer>
    </div>
    <table>
      <tbody>
        <tr
          v-for="index of week"
          :key="index"
          :data-week="addDateWeekNum(index)"
        >
          <th>{{ addDateWeek(index) }}</th>
          <td
            v-for="i of weekNum * 1"
            :key="i"
            :class="{ holiday: isHoliday(index + (i - 1) * 7) }"
          >
            <div v-html="addDateHtml(index + (i - 1) * 7)"></div>
            <p class="holiday-text" v-if="isHoliday(index + (i - 1) * 7)">
              {{ holiday[addDateFormat(index + (i - 1) * 7)] }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";

import dayjs from "dayjs";
import axios from "axios";
require("dayjs/locale/ja");
dayjs.locale("ja");
import drag from "@branu-jp/v-drag";
export default {
  name: "App",
  components: {
    Logo
  },
  directives: {
    drag
  },
  data() {
    return {
      date: dayjs()
        .day(1)
        .format("YYYY-MM-DD"),
      weekNum: 4,
      week: [0, 1, 2, 3, 4, 5, 6],
      holiday: null,
      dialogStyle: {
        top: 24 + "px",
        right: 24 + "px"
      }
    };
  },
  mounted() {
    axios
      .get("https://holidays-jp.github.io/api/v1/date.json")
      .then(response => (this.holiday = response.data));
  },
  computed: {
    classWeek() {
      return {
        active: this.isActive && !this.error,
        "text-danger": this.error && this.error.type === "fatal"
      };
    }
  },
  methods: {
    isHoliday(date) {
      if (this.holiday && this.holiday[this.addDateFormat(date)]) {
        console.log(this.holiday[this.addDateFormat(date)]);
        return true;
      } else {
        return false;
      }
    },
    addDateWeek(addDay) {
      return dayjs(this.date)
        .add(addDay, "days")
        .format("dd");
    },
    addDateWeekNum(addDay) {
      return dayjs(this.date)
        .add(addDay, "days")
        .format("d");
    },
    addDateHtml(addDay) {
      const day = dayjs(this.date).add(addDay, "days");
      return `<small>${day.format("M")}/</small>${day.format(
        "DD"
      )}<small>(${day.format("dd")})</small>`;
    },
    addDateFormat(addDay) {
      return dayjs(this.date)
        .add(addDay, "days")
        .format("YYYY-MM-DD");
    }
  }
};
</script>

<style lang="scss">
body {
  padding: 0;
  margin: 0;
  color: #222;
  font-family: sans-serif;
}
.control {
  user-select: none;
  cursor: move;
  position: absolute;
  width: 360px;
  z-index: 99999;
  border-radius: 3px;
  border: 1px solid #0194c3;
  background: rgba(rgb(231, 236, 238), 0.9);
  box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.3);
  @media print {
    display: none;
  }
  h1 {
    background: #0194c3;
    color: #fff;
    margin: 0;
    padding: 8px;
    font-size: 22px;
    font-weight: 300;
    line-height: 1;
    display: flex;
    small {
      font-size: 75%;
    }
    // justify-content: center;
    align-items: center;
    svg {
      margin-right: 8px;
    }
  }
  &-inner {
    padding: 15px;
    padding-top: 10px;
    div {
      margin-top: 5px;
    }
  }
  label {
    display: inline-block;
    width: 10em;
    font-weight: normal;
    font-size: 0.9rem;
  }
  footer {
    background: darken(desaturate(#0194c3, 90%), 0%);
    color: #fff;
    padding: 3px 10px;
    a {
      color: currentColor;
    }
    p {
      text-align: right;
      margin: 0;
      font-size: 10px;
    }
  }
}
$red: #da1858;
$blue: #0077ff;
table {
  border-collapse: collapse;
  width: 100vw;
  height: 100vh;
  th {
    width: 2em;
    font-weight: normal;
    color: #333;
  }
  tr {
    &:nth-child(even) {
      th {
        background: #f5f5f5;
      }
    }
  }
  td {
    padding: 3px;
    vertical-align: top;
    font-size: 1.3rem;
    font-family: sans-serif;
    color: #666;
    position: relative;
    small {
      font-size: 50%;
      font-weight: normal;
      margin: 0 0.25em;
    }
    .holiday-text {
      position: absolute;
      font-size: 0.7rem;
      margin: 0;
      right: 5px;
      top: 5px;
    }
  }
  tr {
    &[data-week="0"] {
      height: 5vh;
      &,
      th,
      td {
        background: mix($red, #fff, 5%);
        color: mix($red, #fff, 50%);
      }
    }
    &[data-week="6"] {
      height: 5vh;
      &,
      th,
      td {
        background: mix($blue, #fff, 3%);
        color: mix($blue, #fff, 50%);
      }
    }
  }
  th,
  td {
    border: 1px solid #ccc;
    &.holiday {
      color: mix($red, #fff, 50%) !important;
      background: mix($red, #fff, 5%) !important;
    }
  }
}
</style>
